import StyledPage from "@entrilia/shared/components/infoPage/StyledPage";
import AccessCheck from "./accessCheck/AccessCheck";

const AccessCheckPage = () => {
  return (
    <StyledPage sx={{ px: 2 }}>
      <AccessCheck />
    </StyledPage>
  );
};

export default AccessCheckPage;
